import React, { useState, createContext, useContext } from 'react';
interface TabsContextType {
  value: string;
  onValueChange: (value: string) => void;
}
const TabsContext = createContext<TabsContextType | undefined>(undefined);
interface TabsProps {
  defaultValue: string;
  children: React.ReactNode;
}
export const Tabs: React.FC<TabsProps> = ({
  defaultValue,
  children
}) => {
  const [value, setValue] = useState(defaultValue);
  return <TabsContext.Provider value={{
    value,
    onValueChange: setValue
  }} data-id="element-1051">
      <div className="tabs" data-id="element-1052">{children}</div>
    </TabsContext.Provider>;
};
interface TabsListProps {
  children: React.ReactNode;
  className?: string;
}
export const TabsList: React.FC<TabsListProps> = ({
  children,
  className = ''
}) => {
  return <div className={`flex space-x-2 ${className}`} data-id="element-1053">{children}</div>;
};
interface TabsTriggerProps {
  value: string;
  children: React.ReactNode;
}
export const TabsTrigger: React.FC<TabsTriggerProps> = ({
  value,
  children
}) => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('TabsTrigger must be used within a Tabs component');
  }
  const isActive = context.value === value;
  return <button className={`px-4 py-2 rounded-lg transition-colors ${isActive ? 'bg-gray-700 text-white' : 'text-gray-400 hover:text-gray-300 hover:bg-gray-700/50'}`} onClick={() => context.onValueChange(value)} data-id="element-1054">
      {children}
    </button>;
};
interface TabsContentProps {
  value: string;
  children: React.ReactNode;
}
export const TabsContent: React.FC<TabsContentProps> = ({
  value,
  children
}) => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('TabsContent must be used within a Tabs component');
  }
  if (context.value !== value) {
    return null;
  }
  return <div data-id="element-1055">{children}</div>;
};